import { SvgIcon, SvgType } from '../../../common/svgIcon/SvgIcon'
import { OnDemandAsides } from './styled'

const OnDemandFile = (props: any) => {
  const { title, url, desc } = props

  return (
    <OnDemandAsides>
      <div className="heading">
        <SvgIcon type={SvgType.PROCEDURALGUIDELINE} />
        <span className="headingTitle">{title || 'Presentation File'}</span>
      </div>
      {desc && <div className="fileDesc">{desc}</div>}
      <a href={url} target="_blank" rel="noreferrer" className="btn btn-danger btn-sm asideBtn">
        <span>
          <SvgIcon type={SvgType.DOWNLOAD} />
        </span>
        <span>Download File</span>
      </a>
    </OnDemandAsides>
  )
}

export default OnDemandFile
